import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const DMA_VIDEO_REPORT_ID = `dma${VIDEO_CAMPAIGN_SUFFIX}`;
